<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE THIRTEENTH</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"><a id="page_iv"></a> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="para"><span class="small">THE THIRTEENTH</span>. Copyright © 2009 by Leslie Esdaile Banks. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para">Banks, L. A.</p>
<p class="para">The thirteenth : a vampire huntress legend / L. A. Banks.—1st ed.</p>
<p class="indent-para">    p.   cm</p>
<p class="indent-para">ISBN-13: 978-0-312-36876-0</p>
<p class="indent-para">ISBN-10: 0-312-36876-3</p>
<p class="indent-para">1. Richards, Damali (Fictitious character)—Fiction. 2. African American women—Fiction. 3. Vampires—Fiction. 4. Armageddon—Fiction. I. Title.</p>
<p class="indent-para">PS3602.A64T47  2009</p>
<p class="indent-para">813'.6—dc22</p>
<p class="right-para">2008037581</p>
<p class="para"> </p>
<p class="para">First Edition: February 2009</p>
<p class="para"> </p>
<p class="para">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?705db90a